export default {
  /**
   * The minimum match score to determine if a string is a match or not. This is a value between
   * zero (no match) and one (full match).
   *
   * See the documentation for the string_score package for more information:
   * https://www.npmjs.com/package/string_score
   */
  minimumStringMatchScore: 0.6,

  /**
   * Special characters and their equivalents for easy string comparison. Characters are looked up
   * via their property name which does not work with these special characters unless they are
   * quoted.
   */
  specialCharacterConversions: {
    /* eslint-disable quote-props */
    '™': '',
    'ü': 'u',
    '°': '',
    '®': '',
    'í': 'i',
    'ē': 'e',
    'ū': 'u',
    /* eslint-enable quote-props */
  },
};
